var React = require('react');

function Container (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M26 7c.552 0 1 .448 1 1v15c0 .552-.448 1-1 1H6c-.552 0-1-.448-1-1V8c0-.552.448-1 1-1h20zM9 9H7v13h2V9zm4 0h-2v13h2V9zm4 0h-2v13h2V9zm4 0h-2v13h2V9zm4 0h-2v13h2V9z"}));
}

Container.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Container;

Container.default = Container;
